import { render, staticRenderFns } from "./Brand_Configuration.vue?vue&type=template&id=eb13748e&"
import script from "./Brand_Configuration.vue?vue&type=script&lang=js&"
export * from "./Brand_Configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports